import React from "react";

function Footer() {
  return (
    <footer>
      <p>Created by abhishek with love.</p>
    </footer>
  );
}

export default Footer;
